import React from "react";
import { Row, Col, Form ,Input, Radio, Button, InputNumber, Select, message,  Icon } from "antd";
import CompanyLosService from "./services/company-los-services";
import PropTypes from "prop-types";
import { GenericToolTip } from "../../components/genericTooltip";
import { ADD_COMMON_FORM } from "./constants/fields_info_json";


const MAX_ROI = 27.375;
class AddCombinationalSchemeDetail extends React.Component {

    state = {
        margin: null,
        tenor: null,
        overdueTenor: null,
        normalRoi: null,
        overdueRoi: null,
        buyerRoi: null,
        sellerRoi: null,
        roiStructure: "Flat",
        stopBillingApplicable: "No",
        stopBillingDays: null,
        coolingPeriod: null,
        cashbackApplicable: "Yes",
        dealerPerc: 100,
        sellerPerc: 0,
        disbursalWaitDays: null,
        subventionPerc: 0,
        subventionDays: 0,
        count: 2,
        insertClick: null,
        insertAboveClick: false,
        insertBelowClick: false,
        countArr: [1],
        countBelow: null,
        countBelowArr: [],
        error: null,
        isTieredAboveEdited: false,
        isTieredBelowEdited: false,
        tieredAboveArr: [],
        tieredBelowArr: [],
        insertBelowArr: null,
        showInsert: true,
        to_days1Err: false,
        from_days2Err: false,
        roi2Err: false,
        aboveT_err_msg: null ,
        non_field_error: null,
        show_api_err: false,
        loading:false,
        lending_partner: null,
        submitRO: true,
        progPerc: 0,
        anchorId: null,
        adhoc_roi_flat: {
            'adhoc_roi_1' : "",
            'adhoc_roi_2' : ""
        },
        adhocApplicableOnOverdue: false,
        additional_roi : ""
    }

    updateLastTiered = () => {
        if (this.state.adhocApplicableOnOverdue) {
            if (this.state.tieredBelowArr.length) {
                this.setState(prevState => {
                    const newArray = [...prevState.tieredBelowArr]; // Clone the array
                    newArray[this.state.tieredBelowArr.length - 1] = { ...newArray[this.state.tieredBelowArr.length - 1], adhoc_roi: (this.state.tieredBelowArr.slice(-2)[0].adhoc_roi) }; // Update the specific object's value
                    return { tieredBelowArr: newArray }; // Update the state with the modified array
                })
            } else {
                this.setState({
                    adhoc_roi_flat: {
                        ...this.state.adhoc_roi_flat,
                        'adhoc_roi_2': this.state.tieredAboveArr.slice(-1)[0]['adhoc_roi']
                    }
                })
            }
        }
        let above_roi = this.state.tieredAboveArr.length ? (this.state.tieredAboveArr.slice(-1)[0]['roi:1'] || this.state.tieredAboveArr.slice(-1)[0]['roi:2']) : this.state.normalRoi;
        let below_roi = this.state.overdueRoi;
        if (this.state.tieredBelowArr.length >= 2) {
            above_roi = this.state.tieredBelowArr.slice(-2)[0]['roi:1'] || this.state.tieredBelowArr.slice(-2)[0]['roi:2']
        }
        let add_roi = (below_roi - above_roi).toFixed(3);
        this.setState({
            additional_roi: add_roi
        })
    }

    handleSubmit = e => {
        // this.setState({
        //     adhocApplicableOnOverdue : false
        // })
        if(this.state.insertClick == "InsertAbove"){
            e.preventDefault();
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    let newObj ={};
                    Object.keys(values).map(_ => {
                        newObj[_.split(":")[1]] = {...newObj[_.split(":")[1]] , [_] : values[_]};
                    });
                    if(this.state.tieredAboveArr.length !==0){
                        this.state.tieredAboveArr.splice(-1);
                        this.setState({ 
                        tieredAboveArr: [...this.state.tieredAboveArr, ...Object.values(newObj)].map(_ => {return {..._, adhoc_roi :  (MAX_ROI - (_['roi:1'] || _['roi:2'])?.toFixed(3) || 0)}}), 
                        isTieredBelowEdited: true, 
                        count: 1, 
                        insertAboveClick: false, 
                        insertBelowClick: false, 
                        showInsert: true
                    }, () => {
                        this.updateLastTiered();
                        
                    });
                    }else{
                        this.setState({ 
                            tieredAboveArr: [...this.state.tieredAboveArr, ...Object.values(newObj)].map(_ => {return {..._, adhoc_roi :  (MAX_ROI - (_['roi:1'] || _['roi:2'])?.toFixed(3) || 0)}}), 
                            isTieredBelowEdited: true, 
                            count: 1, 
                            insertAboveClick: false, 
                            insertBelowClick: false, 
                            showInsert: true
                        }, () => {
                            this.updateLastTiered();
                        });
                    }
                }
            });
        }else{
            e.preventDefault();
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    let newObj ={};
                    Object.keys(values).map(_ => {
                        newObj[_.split(":")[1]] = {...newObj[_.split(":")[1]] , [_] : values[_]};
                    });
                    if(this.state.tieredBelowArr.length !==0){
                        this.state.tieredBelowArr.splice(-1);
                        this.setState({ 
                            tieredBelowArr: [...this.state.tieredBelowArr, ...Object.values(newObj)].map((_,index) => {
                                if (index === [...this.state.tieredBelowArr, ...Object.values(newObj)].length - 1) {
                                    return { 
                                        ..._, 
                                        adhoc_roi: 0 
                                    }; // Return the unchanged element if it's the last one
                                }
                                return { 
                                    ..._, 
                                    adhoc_roi: (MAX_ROI - (_['roi:1'] || _['roi:2'])).toFixed(3) 
                                };
                            }), 
                            isTieredAboveEdited: true, 
                            count: 1, 
                            insertAboveClick: false, 
                            insertBelowClick: false, 
                            showInsert: true
                        }, () => {
                            this.updateLastTiered();
                        });
                    }else{
                        this.setState({ 
                            tieredBelowArr: [...this.state.tieredBelowArr, ...Object.values(newObj)].map((_,index) => {
                                if (index === [...this.state.tieredBelowArr, ...Object.values(newObj)].length - 1) {
                                    return { 
                                        ..._, 
                                        adhoc_roi: 0 
                                    }; // Return the unchanged element if it's the last one
                                }
                                return { 
                                    ..._, 
                                    adhoc_roi: (MAX_ROI - (_['roi:1'] || _['roi:2'])).toFixed(3) 
                                };
                            }), 
                            isTieredAboveEdited: true, 
                            count: 1, 
                            insertAboveClick: false, 
                            insertBelowClick: false, 
                            showInsert: true
                        },() => {
                            this.updateLastTiered();
                        });
                    }
                }
            });
        }  
    };

    handlAboveInpChng=(id, e)=>{
        // this.setState({
        //     to_days1Err: false,
        //     from_days2Err: false,
        //     roi2Err: false,
        //     aboveT_err_msg: null,
        //     roi1Err : false
        // });
        if (this.state.insertAboveClick){
            if (id === "to_days:1") {
                if (parseInt(e) >= parseInt(this.props.form.getFieldValue("from_days:1")) && parseInt(e) < parseInt(this.props.form.getFieldValue("to_days:2"))) {
                    this.props.form.setFieldsValue({
                        "from_days:2": (parseInt(e) + 1).toString()
                    });
                    this.setState({
                        to_days1Err : false,
                    });
                } else {
                    this.setState({
                        to_days1Err: true,
                        aboveT_err_msg: parseInt(e) < parseInt(this.props.form.getFieldValue("from_days:1") )? "To day can not be less than from day" : "To day can not be greater than max days"
   
                    });
                }
            }
            if (id === "from_days:2") {
                if (parseInt(e) <= parseInt(this.props.form.getFieldValue("to_days:2")) && parseInt(e) > parseInt(this.props.form.getFieldValue("from_days:1"))) {
                    this.props.form.setFieldsValue({
                        "to_days:1": parseInt(e) - 1
                    });
                    this.setState({
                        from_days2Err : false
                    });
                } else {
                    this.setState({
                        from_days2Err: true,
                        aboveT_err_msg: parseInt(e) < parseInt(this.props.form.getFieldValue("to_days:2")) ? "Value can not be greater than from days"  : "Value can not be greater than to day",
                    });
                }
            }
            if(id === "roi:2"){
                if (this.state.tieredAboveArr && this.state.tieredAboveArr.length){
                    let aboveLastItem = this.state.tieredAboveArr[this.state.tieredAboveArr.length-1];

                    let check = this.state.tieredBelowArr.length ? this.state.tieredBelowArr[0]["roi:1"] : this.state.overdueRoi;
                    if (e <= parseInt(aboveLastItem["roi:2"])  || e >= parseInt(check)  ) {
                        this.setState({
                            roi2Err: true,
                            aboveT_err_msg: e <= parseInt(aboveLastItem["roi:2"]) ? "Cannot less than above ROI" : "Cannot greater than below ROI"
                        });
                    }else{
                        this.setState({
                            roi2Err : false
                        });
                    }


                }else if (this.state.tieredBelowArr.length) {
                    if (e <= parseInt(this.state.normalRoi)  || e >= parseInt(this.state.tieredBelowArr[0]["roi:1"]) ) {
                        this.setState({
                            roi2Err: true,
                            aboveT_err_msg: e < parseInt(this.state.normalRoi)  ? "Can not less than above ROI" : "Can not be greater than belor ROI"
                        });
                    } else{
                        this.setState({
                            roi2Err: false,
                        });
                    }
                } else if (e <= parseInt(this.state.normalRoi)   || e >= this.state.overdueRoi) {
                    this.setState({
                        roi2Err: true,
                        aboveT_err_msg: e < parseInt(this.state.normalRoi)? "Can not less than above ROI" : "Can not be greater than below ROI"
                    });
                }else{
                    this.setState({
                        roi2Err : false
                    });
                }
            }
        }else{
            if (id === "to_days:1" ) {
                if (parseInt(e) >= this.props.form.getFieldValue("from_days:1") && parseInt(e) < parseInt(this.props.form.getFieldValue("to_days:2")) ) {
                    this.props.form.setFieldsValue({
                        "from_days:2": (parseInt(e) + 1).toString()
                    });
                    this.setState({
                        to_days1Err: false,
                    });
                } else {
                    this.setState({
                        to_days1Err: true,
                        aboveT_err_msg: parseInt(e) < parseInt(this.props.form.getFieldValue("from_days:1")) ? "To day can not be less than from day" : "To day can not be greater than max days"
                    });
                }
            }
            if (id === "from_days:2") {
                if (parseInt(e) <= this.props.form.getFieldValue("to_days:2") && parseInt(e) > parseInt(this.props.form.getFieldValue("from_days:1"))) {
                    this.props.form.setFieldsValue({
                        "to_days:1": parseInt(e) - 1
                    });
                    this.setState({
                        from_days2Err: false
                    });
                } else {
                    this.setState({
                        from_days2Err: true,
                        aboveT_err_msg: parseInt(e) < parseInt(this.props.form.getFieldValue("to_days:2")) ? "Please enter valid value" : "Value can not be greater than to day",
                    });
                }
            }
            if (id === "roi:1") {
                if (this.state.tieredBelowArr && this.state.tieredBelowArr.length) {
                    let belowFirstItem =  this.state.tieredBelowArr[this.state.tieredBelowArr.length - 2];
                    let check = this.state.tieredBelowArr.length ? this.state.tieredBelowArr[this.state.tieredBelowArr.length - 1]["roi:2"] : this.state.overdueRoi;
                    if (e <= belowFirstItem["roi:1"] || e >= check) {
                        this.setState({
                            roi1Err: true,
                            aboveT_err_msg: e < belowFirstItem["roi:1"] ? "Value Can not be less than above ROI" : "Can not be greater than below ROI"
                        });
                    } else {
                        this.setState({
                            roi1Err: false
                        });
                    }
                } else if (this.state.tieredAboveArr.length){
                    if (e <= parseInt(this.state.tieredAboveArr[this.state.tieredAboveArr.length - 1]["roi:2"])   || e >= this.state.overdueRoi ) {
                        this.setState({
                            roi1Err: true,
                            aboveT_err_msg: e < parseInt(this.state.tieredAboveArr[this.state.tieredAboveArr.length - 1]["roi:2"]) ? "Value can not be less than above ROI" : "Value can not be greater than below ROI"
                        });
                    }else{
                        this.setState({
                            roi1Err: false
                        });
                    }
                } else if (e <= parseInt(this.state.normalRoi) || e > this.state.overdueRoi-1) {
                    this.setState({
                        roi1Err: true,
                        aboveT_err_msg: e <= parseInt(this.state.normalRoi) ? "Value can not be less than above ROI" : "Value can not be greater than belove ROI"
                    });
                } else if (!(e <= parseInt(this.state.normalRoi) | e > this.state.overdueRoi - 1)) {
                    this.setState({
                        roi1Err: false
                    });
                }
            }
        }
    }

    closeAddTiered = () => {
        if (this.state.insertAboveClick){
            this.setState({
                isTieredAboveEdited : false,
                insertAboveClick : false,
                showInsert : true
            });
        }else{
            this.setState({
                isTieredBelowEdited: false,
                insertBelowClick: false,
                showInsert : true
            });
        }
    }

    getValueByPrefix(obj, prefix) {
        const key = Object.keys(obj).find(k => k.startsWith(prefix + ":"));
        return key ? obj[key] : "";
    }


    handleSubventionDaysCalculation = () => {
        let json = {}
        if(this.state.roiStructure == "Flat"){
            json = {
                roi_schedule0from_days: 1,
                roi_schedule0to_days:this.state.overdueTenor,
                roi_schedule0roi: this.state.normalRoi,
                roi_schedule1from_days: '',
                roi_schedule1to_days: "",
                roi_schedule1roi: "",
                roi_schedule2from_days: "",
                roi_schedule2to_days:  "",
                roi_schedule2roi: "",
                roi_schedule3from_days: "",
                roi_schedule3to_days: "",
                roi_schedule3roi: "",
                min_normal_roi_buyer: this.state.buyerRoi,
                min_normal_roi_seller: this.state.sellerRoi,
                subvention_perc: this.state.subventionPerc
            }
        }else{
            const {overdueTenor, normalRoi, tieredAboveArr , tieredBelowArr} = this.state;
            let tiered_array = [...tieredAboveArr, ...tieredBelowArr]
            if(!tieredAboveArr.length){
                let fixedAboveArr = {
                    "from_days:0": 1,
                    "to_days:0": overdueTenor,
                    "roi:0": normalRoi,
                };
                tiered_array.unshift(fixedAboveArr)
            }
            if(tieredBelowArr.length){
                tiered_array.pop()
            }
            console.log("tiered_array" , tiered_array);
            
            json = {
                min_normal_roi_buyer: this.state.buyerRoi,
                min_normal_roi_seller: this.state.sellerRoi,
                subvention_perc: this.state.subventionPerc
            }
            for (let i = 0; i <= 2; i++) {
                if (i <= tiered_array.length){
                    const data = tiered_array[i];

                    json[`roi_schedule${i}from_days`] = data ? this.getValueByPrefix(data, "from_days") || "" : "";
                    json[`roi_schedule${i}to_days`] = data ? this.getValueByPrefix(data, "to_days") || "" : "";
                    json[`roi_schedule${i}roi`] = data ? this.getValueByPrefix(data, "roi") || "" : "";
                }
                else{
                    break;
                }
            }
        }
        CompanyLosService.getSubventionPercentage(json)
            .then((resp) => {
                this.setState({
                    subventionDays: resp.data.subvention_days
                });
            })
            .catch((err) => {
                console.error("Error fetching subvention percentage:", err);
            });

    }


    focusOutEvent = (errState , fieldName) => {
        console.log("fieldName", fieldName);
        if (this.state[errState]){
            this.props.form.setFieldsValue({
                [fieldName] : ""
            });
            this.setState({
                [errState] : false
            });
        }
    }
    renderFlatTieredSection=()=>{
        if(this.state.roiStructure == "Flat" && this.state.overdueTenor && this.state.normalRoi && this.state.overdueRoi){
            return (
                <Col span={24}>
                    <Row className={"text-center mt-10"}>
                        <Col span={6}>
                            From Day: 1
                        </Col>
                        <Col span={6}>
                            To Day: {this.state.overdueTenor}
                        </Col>
                        <Col span={6}>
                            ROI: {this.state.normalRoi}
                        </Col>
                        <Col span={6}>
                            <InputNumber
                                disabled
                                min={0}
                                onChange={(val) => this.setState({
                                    adhoc_roi_flat :{
                                        ...this.state.adhoc_roi_flat,
                                        'adhoc_roi_1': val ,
                                        'adhoc_roi_2': this.state.adhocApplicableOnOverdue ? val : this.state.adhoc_roi_flat['adhoc_roi_2']
                                    }
                                })}
                                value={this.state.adhoc_roi_flat.adhoc_roi_1}
                                placeholder="Adhoc ROI"
                                precision={3}
                                style={{ width: "80%" }}
                            />
                        {(this.state.adhoc_roi_flat.adhoc_roi_1 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_1 > (52 - this.state.normalRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}
                        </Col>  
                    </Row>
                    <Row className={"text-center"} style={{marginTop: "20px", marginBottom: "20px"}}>
                        <Col span={6}>
                            From Day: {Number(this.state.overdueTenor)+1}
                        </Col>
                        <Col span={6}>
                            To Day: 9999
                        </Col>
                        <Col span={6}>
                            ROI: {this.state.overdueRoi}
                        </Col>
                        <Col span={6}>
                            <InputNumber
                                min={0}
                                onChange={(val) => this.setState({
                                    adhoc_roi_flat :{
                                        ...this.state.adhoc_roi_flat,
                                        'adhoc_roi_2': val 
                                    }
                                })}
                                value={this.state.adhoc_roi_flat.adhoc_roi_2}
                                placeholder="Adhoc ROI"
                                precision={3}
                                style={{ width: "80%" }}
                            />
                        {(this.state.adhoc_roi_flat.adhoc_roi_2 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_2 > (52 - this.state.overdueRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}
                        </Col>
                    </Row>
                </Col>
            );
        }else if(this.state.roiStructure == "Tiered" && this.state.overdueTenor && this.state.normalRoi && this.state.overdueRoi){
            return (
                <Col span={24} className={"form_fields_width"}>
                    <Row>
                        {
                            this.state.tieredAboveArr.length !== 0? this.state.showInsert?this.state.tieredAboveArr.map((item, k) => {
                                return(
                                    <Row key={k} className={"text-center mt-10 "}>
                                        <Col span={6}>
                                            <span className="text_blue">From Day {Object.values(item)[0]}</span>
                                        </Col>
                                        <Col span={6}>
                                            <span className="text_blue">To Day {Object.values(item)[1]}</span>
                                        </Col>
                                        <Col span={6}>
                                            <span className="text_blue">ROI {Object.values(item)[2]}</span>
                                        </Col>
                                        <Col span={6}>
                                            <InputNumber
                                                min={0}
                                                onChange={(val) =>{
                                                    if(!this.state.tieredBelowArr.length && k == this.state.tieredAboveArr.length -1 && this.state.adhocApplicableOnOverdue) {
                                                        this.setState({
                                                            adhoc_roi_flat: {
                                                                ...this.state.adhoc_roi_flat,
                                                                adhoc_roi_2: val
                                                            }
                                                        })
                                                    }
                                                    this.setState(prevState => {
                                                        const newArray = [...prevState.tieredAboveArr]; // Clone the array
                                                        newArray[k] = {...newArray[k], adhoc_roi: val}; // Update the specific object's value
                                                        return { tieredAboveArr: newArray }; // Update the state with the modified array
                                                     })
                                                }}
                                                value={this.state.tieredAboveArr[k].adhoc_roi}
                                                placeholder="Adhoc ROI"
                                                precision={3}
                                                style={{ width: "80%" }}
                                            />
                                            {(this.state.tieredAboveArr[k].adhoc_roi > 52 || (this.state.tieredAboveArr[k].adhoc_roi > (52 - Object.values(item)[2])))  && <span className="input-err">{'Please enter correct value'}</span>}
                                        </Col>
                                    </Row>
                                );
                            }):this.state.tieredAboveArr.map((item, k) => {
                                if (this.state.insertAboveClick && k == this.state.tieredAboveArr.length - 1) {
                                    return;
                                }
                                return(
                                    <Row key={k} className={"text-center"}>
                                        <Col span={8}>
                                            <span className="text_blue">From Day {Object.values(item)[0]}</span>
                                        </Col>
                                        <Col span={8}>
                                            <span className="text_blue">To Day {Object.values(item)[1]}</span>
                                        </Col>
                                        <Col span={8}>
                                            <span className="text_blue">ROI {Object.values(item)[2]}</span>
                                        </Col>
                                    </Row>
                                );
                            }):null
                        }
                        {this.state.insertAboveClick && !this.state.isTieredAboveEdited ?
                            <Form onSubmit={this.handleSubmit}>
                                <React.Fragment key={1}>
                                    <Row style={{marginBottom: "20px"}}>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"From Days:"}>
                                                {this.props.form.getFieldDecorator("from_days:" + 1, {
                                                    rules: [{ required: true, message: "Please input From Days" }],
                                                })(
                                                    <Input
                                                        placeholder="From Days"
                                                        onChange={(e) => this.handlAboveInpChng("from_days:1", e)}
                                                        className={"read-only-input"}
                                                        readOnly={true}
                                                        style={{width : "80%"}}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"To Days:"} style={{margin: "0"}}>
                                                {this.props.form.getFieldDecorator("to_days:1", {
                                                    rules: [{ required: true, message: "Please input To Days" }],
                                                })(
                                                    <InputNumber
                                                        precision={0}
                                                        onBlur={() => this.focusOutEvent("to_days1Err", "to_days:1")}
                                                        placeholder="To Days"
                                                        onChange={(e) => this.handlAboveInpChng("to_days:1", e)}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.to_days1Err && <span style={{fontSize: "11px", color: "red"}}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"ROI:"}>
                                                {this.props.form.getFieldDecorator("roi:1", {
                                                    rules: [{ required: true, message: "Please input ROI" }],
                                                })(
                                                    <InputNumber
                                                        precision={3}
                                                        placeholder="ROI"
                                                        onChange={(e) => this.handlAboveInpChng("roi:1", e)}
                                                        readOnly={true}
                                                        className={"read-only-input"}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row style={{marginBottom: "20px"}}>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"From Days:"}>
                                                {this.props.form.getFieldDecorator("from_days:2", {
                                                    rules: [{ required: true, message: "Please input From Days" }],
                                                })(
                                                    <InputNumber
                                                        precision={0}
                                                        placeholder="From Days"
                                                        onChange={(e) => this.handlAboveInpChng("from_days:2", e)}
                                                        onBlur={() => this.focusOutEvent("from_days2Err", "from_days:2")}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.from_days2Err && <span style={{fontSize: "11px", color: "red"}}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"To Days:"}>
                                                {this.props.form.getFieldDecorator("to_days:2", {
                                                    rules: [{ required: true, message: "Please input To Days" }],
                                                })(
                                                    <Input
                                                        placeholder="To Days"
                                                        onChange={(e) => this.handlAboveInpChng("to_days:2", e)}
                                                        readOnly={true}
                                                        className={"read-only-input"}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"ROI:"}>
                                                {this.props.form.getFieldDecorator("roi:2", {
                                                    rules: [{ required: true, message: "Please input ROI" }],
                                                })(
                                                    <InputNumber
                                                        placeholder="ROI"
                                                        onChange={(e) => this.handlAboveInpChng("roi:2", e)}
                                                        precision={3}
                                                        onBlur={() => this.focusOutEvent("roi2Err", "roi:2")}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.roi2Err && <span style={{fontSize: "11px", color: "red"}}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                <Col span={8}>
                                    <Form.Item>
                                        <Button className="mr-2" disabled={this.state.roi2Err || this.state.roi1Err || this.state.from_days2Err || this.state.to_days1Err} type="primary" htmlType="submit">
                                            Save
                                        </Button>
                                        <Button type="text" onClick={this.closeAddTiered}>
                                            Cancel
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Form> : this.state.tieredAboveArr.length==0?<Row className={"text-center"}>
                                <Col span={6}>
                                    <span className="text_blue">From Day 1</span>
                                </Col>
                                <Col span={6}>
                                    <span className="text_blue">To Day {this.state.overdueTenor}</span>
                                </Col>
                                <Col span={6}>
                                    <span className="text_blue"> ROI {this.state.normalRoi}</span>
                                </Col>
                                <Col span={6}>
                                    <InputNumber
                                        min={0}
                                        onChange={() => {
                                            if (!this.state.tieredAboveArr.length && !this.state.tieredBelowArr.length && this.state.adhocApplicableOnOverdue) {
                                                this.setState({
                                                    adhoc_roi_flat: {
                                                        ...this.state.adhoc_roi_flat,
                                                        'adhoc_roi_2': val,
                                                        'adhoc_roi_1': val
                                                    }
                                                })
                                            } else {
                                                this.setState({
                                                    adhoc_roi_flat: {
                                                        ...this.state.adhoc_roi_flat,
                                                        'adhoc_roi_1': val
                                                    }
                                                })
                                            }
                                        }
                                        }
                                        
                                       
                                        value={this.state.adhoc_roi_flat.adhoc_roi_1}
                                        placeholder="Adhoc ROI"
                                        precision={3}
                                        style={{ width: "80%" }}
                                    />
                                    {(this.state.adhoc_roi_flat.adhoc_roi_1 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_1 > (52 - this.state.normalRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}
                                </Col>
                            </Row>:null}
                    </Row>
                    <Row>
                        <Col offset={16}>
                            {this.state.showInsert?<React.Fragment><a className="text_blue" onClick={() => this.onInsertClick("InsertAbove")}>Insert Above</a> / <a onClick={() => this.onInsertClick("InsertBelow")}>Insert Below</a></React.Fragment>:null}
                            <br/>
                            {this.state.tieredAboveArr.length == 0 && this.state.tieredBelowArr.length == 0 ? <span style={{color: "red"}}>*Add at least one tier</span>:null}
                        </Col>
                    </Row>
                    <Row style={{marginBottom: "20px"}}>
                        {
                            this.state.tieredBelowArr.length !== 0? this.state.showInsert?this.state.tieredBelowArr.map((item, k) => {
                                return(
                                    <Row key={k} className={"text-center mt-10"}>
                                        <Col span={6}>
                                            From Day {Object.values(item)[0]}
                                        </Col>
                                        <Col span={6}>
                                            To Day {Object.values(item)[1]}
                                        </Col>
                                        <Col span={6}>
                                            ROI {Object.values(item)[2]}
                                        </Col>
                                        <Col span={6}>
                                            <InputNumber
                                                min={0}
                                                disabled = {k === this.state.tieredBelowArr.length - 1}
                                                onChange={(val) => {
                                                    if (k === this.state.tieredBelowArr.length - 2 && this.state.adhocApplicableOnOverdue) {
                                                        this.setState(prevState => {
                                                            const newArray = [...prevState.tieredBelowArr]; // Clone the array
                                                            newArray[this.state.tieredBelowArr.length - 1] = { ...newArray[this.state.tieredBelowArr.length - 1], adhoc_roi: val }; // Update the specific object's value
                                                            newArray[k] = { ...newArray[k], adhoc_roi: val }; // Update the specific object's value
                                                            return { tieredBelowArr: newArray }; // Update the state with the modified array

                                                        })
                                                    } else {
                                                        this.setState(prevState => {
                                                            const newArray = [...prevState.tieredBelowArr]; // Clone the array
                                                            newArray[k] = { ...newArray[k], adhoc_roi: val }; // Update the specific object's value
                                                            return { tieredBelowArr: newArray }; // Update the state with the modified array
                                                        })
                                                    }

                                                }}
                                              
                                                value={this.state.tieredBelowArr[k].adhoc_roi}
                                                placeholder="Adhoc ROI"
                                                precision={3}
                                                style={{ width: "80%" }}
                                            />
                                            {(this.state.tieredBelowArr[k].adhoc_roi > 52 || (this.state.tieredBelowArr[k].adhoc_roi > (52 - Object.values(item)[2])))  && <span className="input-err">{'Please enter correct value'}</span>}
                                        </Col>
                                    </Row>
                                );
                            }):this.state.tieredBelowArr.map((item, k) => {
                                if (this.state.insertBelowClick && k == this.state.tieredBelowArr.length - 1) {
                                    return;
                                }
                                return(
                                    <Row key={k} className={"text-center"}>
                                        <Col span={8}>
                                            From Day {Object.values(item)[0]}
                                        </Col>
                                        <Col span={8}>
                                            To Day {Object.values(item)[1]}
                                        </Col>
                                        <Col span={8}>
                                            ROI {Object.values(item)[2]}
                                        </Col>
                                    </Row>
                                );
                            }):null
                        }
                        {this.state.insertBelowClick && !this.state.isTieredBelowEdited ?
                            <Form onSubmit={this.handleSubmit}>
                                <React.Fragment key={1}>
                                    <Row style={{ marginBottom: "20px" }}>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"From Days:"}>
                                                {this.props.form.getFieldDecorator("from_days:" + 1, {
                                                    rules: [{ required: true, message: "Please input From Days" }],
                                                })(
                                                    <Input
                                                        placeholder="From Days"
                                                        className={"read-only-input"}
                                                        readOnly={true}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"To Days:"} style={{ margin: "0" }}>
                                                {this.props.form.getFieldDecorator("to_days:1", {
                                                    rules: [{ required: true, message: "Please input To Days" }],
                                                })(
                                                    <InputNumber
                                                        precision={0}
                                                        placeholder="To Days"
                                                        onChange={(e) => this.handlAboveInpChng("to_days:1", e)}
                                                        onBlur={() => this.focusOutEvent("to_days1Err", "to_days:1")}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.to_days1Err && <span style={{ fontSize: "10px", color: "red" }}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={1} label={"ROI:"}>
                                                {this.props.form.getFieldDecorator("roi:1", {
                                                    rules: [{ required: true, message: "Please input ROI" }],
                                                })(
                                                    <InputNumber
                                                        placeholder="ROI"
                                                        onChange={(e) => this.handlAboveInpChng("roi:1", e)}
                                                        precision={3}
                                                        onBlur={() => this.focusOutEvent("roi1Err", "roi:1")}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.roi1Err && <span style={{ fontSize: "10px", color: "red" }}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginBottom: "20px" }}>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"From Days:"}>
                                                {this.props.form.getFieldDecorator("from_days:2", {
                                                    rules: [{ required: true, message: "Please input From Days" }],
                                                })(
                                                    <InputNumber
                                                        placeholder="From Days"
                                                        onChange={(e) => this.handlAboveInpChng("from_days:2", e)}
                                                        onBlur={() => this.focusOutEvent("from_days2Err", "from_days:2")}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.from_days2Err && <span style={{ fontSize: "10px", color: "red" }}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"To Days:"}>
                                                {this.props.form.getFieldDecorator("to_days:2", {
                                                    rules: [{ required: true, message: "Please input To Days" }],
                                                })(
                                                    <Input
                                                        placeholder="To Days"
                                                        readOnly={true}
                                                        className={"read-only-input"}
                                                        style={{ width: "80%" }}
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item key={2} label={"ROI:"}>
                                                {this.props.form.getFieldDecorator("roi:2", {
                                                    rules: [{ required: true, message: "Please input ROI" }],
                                                })(
                                                    <Input
                                                        placeholder="ROI"
                                                        readOnly={true}
                                                        className={"read-only-input"}
                                                        style={{width : "80%"}}
                                                    />,
                                                )}
                                            </Form.Item>
                                            {this.state.roi2Err && <span style={{ fontSize: "10px", color: "red" }}>{this.state.aboveT_err_msg}</span>}
                                        </Col>
                                    </Row>
                                </React.Fragment>
                                <Col span={8}>
                                    <Form.Item>
                                        <Button className="mr-2" disabled={this.state.roi2Err || this.state.roi1Err || this.state.from_days2Err || this.state.to_days1Err} type="primary" htmlType="submit">
                                            Save
                                        </Button>
                                        <Button type="text" onClick={this.closeAddTiered}>
                                            Cancel
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Form> : this.state.tieredBelowArr.length==0?<Row className={"text-center"}>
                                <Col span={6}>
                                    From Day {Number(this.state.overdueTenor) + 1}
                                </Col>
                                <Col span={6}>
                                    To Day 9999
                                </Col>
                                <Col span={6}>
                                    ROI {this.state.overdueRoi}
                                </Col>
                                <Col span={6}>
                                    <InputNumber
                                        disabled
                                        min={0}
                                        onChange={(val) => this.setState({
                                            adhoc_roi_flat: {
                                                ...this.state.adhoc_roi_flat,
                                                'adhoc_roi_2': val
                                            }
                                        })}
                                        value={this.state.adhoc_roi_flat['adhoc_roi_2']}

                                        placeholder="Adhoc ROI"
                                        precision={3}
                                        style={{ width: "80%" }}
                                    />
                                    {(this.state.adhoc_roi_flat.adhoc_roi_2 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_2 > (52 - this.state.overdueRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}                            
                                </Col>
                            </Row>:null}
                    </Row>
                </Col>
            );
        }
    }

    onInsertClick(item){
        if(item == "InsertBelow"){
            this.setState({
                isTieredBelowEdited: false,
                showInsert: false
            });
            if(this.state.tieredBelowArr.length !== 0){
                let lastElement = this.state.tieredBelowArr[this.state.tieredBelowArr.length - 1];
                this.setState({insertAboveClick: false, insertClick: item, insertBelowClick: true} , () =>{
                    this.props.form.setFieldsValue({
                        ["from_days:1"]: Object.values(lastElement)[0],
                        ["to_days:2"]: Object.values(lastElement)[1],
                        ["roi:2"]: Object.values(lastElement)[2],
                    });
                });
            }else{
                this.setState({insertAboveClick: false, insertClick: item, insertBelowClick: true} , () =>{
                    this.props.form.setFieldsValue({
                        ["from_days:1"]: (Number(this.state.overdueTenor)+1).toString(),
                        ["to_days:2"]: "9999",
                        ["roi:2"]: this.state.overdueRoi,
                    });
                });
            }
        }else{
            this.setState({
                isTieredAboveEdited: false,
                showInsert: false
            });
            if(this.state.tieredAboveArr.length !== 0){
                let lastElement = this.state.tieredAboveArr[this.state.tieredAboveArr.length - 1];
                this.setState({insertAboveClick: true, insertClick: item, insertBelowClick: false} , () =>{
                    this.props.form.setFieldsValue({
                        ["from_days:1"]: Object.values(lastElement)[0],
                        ["to_days:2"]: Object.values(lastElement)[1],
                        ["roi:1"]: Object.values(lastElement)[2],
                    });
                });
            }else{
                this.setState({insertAboveClick: true, insertClick: item, insertBelowClick: false} , () =>{
                    this.props.form.setFieldsValue({
                        ["from_days:1"]: "1",
                        ["to_days:2"]: this.state.overdueTenor,
                        ["roi:1"]: this.state.normalRoi,
                    });
                });
            }
        }
    }

    focusOutEvent =(stateName, errorName)=>{
         if(stateName == "subventionPerc"){
            this.handleSubventionDaysCalculation()
        }
        if(this.state[errorName]){
            this.setState({
                [stateName]: null,
                [errorName]: false
            });
        }else{
            this.setState({
                [errorName]: false
            });
        }
    }

    fieldCheckValidations(item, value){
        const {sellerPerc, dealerPerc} = this.state;
        this.setState({
            error: null,
            marginErr: false,
            tenorErr: false,
            normalRoiErr: false,
            overdueRoiErr: false,
            stopBillingDayErr: false,
            cpErr: false,
            dealerPerErr: false,
            sellerPerErr: false,
            progPerErr: false,
            subventionPercErr: false,
            disbursalWaitDaysErr: false
        });
        if(item == "Margin"){
            if(value < 0 || value > 100){
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    marginErr: true
                });
            }
            if(this.props.anchorList?.length == 1){
                this.setState({
                    anchorId: this.props.anchorList[0].id
                });
            }
        }
        if(item == "Tenor"){
            if(value <= 0 || value >365){
                this.setState({
                    error: "Please enter correct value.",
                    tenorErr: true
                });
            }else{
                this.setState({
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }
        }
        if(item == "Normal ROI"){
            if(this.props.schemeTypeData == 3){
                if(value < 0 || value > 100 || value < this.state.buyerRoi || value == this.state.buyerRoi){
                    this.setState({
                        error: "Enter valid input",
                        normalRoiErr: true,
                        sellerRoi: null
                    });
                }else{
                    const sellRoi = value - this.state.buyerRoi;
                    const subvention_days = sellRoi ?Math.floor((this.state.subventionPerc / (sellRoi / 365)).toFixed(2)):0;
                    this.setState({
                        subventionDays: subvention_days,
                        sellerRoi: sellRoi,
                        roiStructure: "Flat"
                    });
                    this.resetTiered();
                }
            }else{
                if(value < 0 || value > 100){
                    this.setState({
                        error: "Value can't be less than 0 or greater than 100",
                        normalRoiErr: true
                    });
                }else{
                    const subvention_days = value ?Math.floor((this.state.subventionPerc / (value / 365)).toFixed(2)):0;
                    this.setState({
                        subventionDays: subvention_days,
                        roiStructure: "Flat"
                    });
                    this.resetTiered();
                }   
            }
        }
        if(item == "Buyer ROI"){
            if(value < 0 || value > 100 || value > this.state.normalRoi || value == this.state.normalRoi){
                this.setState({
                    error: "Enter valid input",
                    buyerRoiErr: true,
                    sellerRoi: null
                });
            }else{
                const sellRoi = this.state.normalRoi - value;
                const subvention_days = sellRoi ?Math.floor((this.state.subventionPerc / (sellRoi / 365)).toFixed(2)):0;
                this.setState({
                    subventionDays: subvention_days,
                    sellerRoi: this.state.normalRoi - value,
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }
        }
        if(item == "Overdue ROI"){
            if(value < 0 || value > 100){
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    overdueRoiErr: true,
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }else if(value < this.state.normalRoi || value == this.state.normalRoi){
                this.setState({
                    error: "Plese enter correct value.",
                    overdueRoiErr: true,
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }else {
                this.setState({
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }
        }
        if(item == "Stop Billing Days"){
            if(value <= 0){
                this.setState({
                    error: "Value must be greater than 0",
                    stopBillingDayErr: true
                });
            }else if(value > this.state.overdueTenor){
                this.setState({
                    error: "Value can't be greater than tenor day",
                    stopBillingDayErr: true
                });
            }
        }
        if(item == "Cooling Period"){
            if(value <0){
                this.setState({
                    error: "Value can't be less than 0",
                    cpErr: true
                });
            }else if(value > this.state.overdueTenor){
                this.setState({
                    error: "Value can't be greater than tenor day",
                    cpErr: true
                });
            }
        }
        if(item == "Dealer %"){
            if(value < 0 || value > 100){
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    dealerPerErr: true
                });
            }else{
                if(100-sellerPerc-value > 0 || 100-sellerPerc-value == 0){
                    if(sellerPerc != 100){
                        this.setState({
                            progPerc: (100-sellerPerc-value).toFixed(2)
                        });
                    }else{
                        this.setState({
                            progPerc: 0
                        });
                    }
                }else{
                    this.setState({
                        error: "Value can't be less than 0 or greater than 100",
                        progPerErr: true,
                        progPerc: 0
                    });
                }
            }
        }
        if(item == "Seller %"){
            if(value < 0 || value > 100){
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    sellerPerErr: true
                });
            }else{
                if(100-dealerPerc-value > 0 || 100-dealerPerc-value == 0){
                    if(dealerPerc != 100){
                        this.setState({
                            progPerc: (100-dealerPerc-value).toFixed(2)
                        });
                    }else{
                        this.setState({
                            progPerc: 0
                        });
                    }
                }else{
                    this.setState({
                        error: "Value can't be less than 0 or greater than 100",
                        progPerErr: true,
                        progPerc: 0
                    });
                }
            }
        }
        if(item == "Subvention %"){
            if(value < 0 || value > 100){
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    subventionPercErr: true
                });
            }else{
                if(this.state.normalRoi){
                    // if(this.props.schemeTypeData == 3){
                    //     const subvention_days = Math.floor((value / (this.state.sellerRoi / 365))?.toFixed(2));
                    //     this.setState({
                    //         subventionDays: subvention_days
                    //     });
                    // }else{
                    //     const subvention_days = Math.floor((value / (this.state.normalRoi / 365))?.toFixed(2));
                    //     this.setState({
                    //         subventionDays: subvention_days
                    //     });
                    // }
                }else{
                    this.setState({
                        error: "Please enter Normal ROI",
                        subventionPercErr: true
                    });
                }
            }
        }
        if(item == "Disbursal wait days"){
            if(value > this.state.overdueTenor){
                this.setState({
                    disbursalWaitDaysErr: true,
                    error: "Value can't be greater than tenor day."
                });
            }
        }
    }

    checkSubmit = () => {
        const {margin, cashbackApplicable, overdueTenor, normalRoi, overdueRoi, buyerRoi, roiStructure, stopBillingApplicable, stopBillingDays, coolingPeriod, dealerPerc, sellerPerc, progPerErr, disbursalWaitDays, subventionPerc, subventionDays, anchorId} = this.state;
        if(this.state.additional_roi < 0 || this.state.additional_roi > this.state.overdueRoi){
            return true;
        }
        if (roiStructure == "Flat"){
            if(Object.values(this.state.adhoc_roi_flat).some(x => x === null || x === '')){
                return true;
            }
        } else if (roiStructure == "Tiered") {
            const hasTieredAbove = this.state.tieredAboveArr.length;
            const hasTieredBelow = this.state.tieredBelowArr.length;
            const nullInTieredAbove = this.state.tieredAboveArr.some(x => (!x.hasOwnProperty('adhoc_roi') || (x['adhoc_roi'] === null || x['adhoc_roi'] === '')));
            const nullInTieredBelow = this.state.tieredBelowArr.some(x => (!x.hasOwnProperty('adhoc_roi') || (x['adhoc_roi'] === null || x['adhoc_roi'] === '')));

            if ((hasTieredAbove ? nullInTieredAbove : [null, ""].includes(this.state.adhoc_roi_flat['adhoc_roi_1'])) ||
                (hasTieredBelow ? nullInTieredBelow : [null, ""].includes(this.state.adhoc_roi_flat['adhoc_roi_2']))) {
                return true;
            }
        }
        if(this.props.schemeTypeData == 3){
            if(stopBillingApplicable == "No"){
                if(cashbackApplicable == "No"){
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || buyerRoi ==null || roiStructure == null || coolingPeriod ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || buyerRoi ==null || roiStructure == null || coolingPeriod ==null || dealerPerc ==null || sellerPerc ==null || progPerErr ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        if(subventionPerc == 0){
                            return true;
                        }else{
                            return false;
                        }
                    }
                }
            }else{
                if(cashbackApplicable == "No"){
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || buyerRoi ==null || roiStructure == null || stopBillingDays ==null || coolingPeriod ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || buyerRoi ==null || roiStructure == null || stopBillingDays ==null || coolingPeriod ==null || dealerPerc ==null || sellerPerc ==null || progPerErr == null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        if(subventionPerc == 0){
                            return true;
                        }else{
                            return false;
                        }
                    }
                }
            }
        }else{
            if(stopBillingApplicable == "No"){
                if(cashbackApplicable == "No"){
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || roiStructure == null || coolingPeriod ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || roiStructure == null || coolingPeriod ==null || dealerPerc ==null || sellerPerc ==null || progPerErr ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        if(subventionPerc == 0){
                            return true;
                        }else{
                            return false;
                        }
                    }
                }
            }else{
                if(cashbackApplicable == "No"){
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || roiStructure == null || stopBillingDays ==null || coolingPeriod ==null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    if(margin ==null || overdueTenor ==null || normalRoi ==null || overdueRoi ==null || roiStructure == null || stopBillingDays ==null || coolingPeriod ==null || dealerPerc ==null || sellerPerc ==null || progPerErr == null || disbursalWaitDays ==null || subventionPerc ==null || subventionDays==null || anchorId==null){
                        return true;
                    }else{
                        if(subventionPerc == 0){
                            return true;
                        }else{
                            return false;
                        }
                    }
                }
            }
        }
    }

    resetLastTiered = () => {
        const {adhocApplicableOnOverdue} = this.state;
        this.setState({
            adhoc_roi_flat : {
                ...this.state.adhoc_roi_flat,
                'adhoc_roi_1' : MAX_ROI -  this.state.normalRoi,
                'adhoc_roi_2': adhocApplicableOnOverdue ?  MAX_ROI - this.state.normalRoi  : 0
            }
        })
    }

    setTieredData(item){
        this.resetLastTiered();

        this.setState({roiStructure: item.target.value,
            additional_roi : this.state.overdueRoi - this.state.normalRoi, 
            subventionPerc: 0,
            progcapSubventionDay : 0
        }, this.props.form.setFieldsValue({
            ["from_days:1"]: "1",
            ["to_days:2"]: this.state.overdueTenor,
            ["roi:1"]: this.state.normalRoi,
        }));
    }

    onSchemeAddClick=()=>{
        const {margin, tenor, overdueTenor, normalRoi, overdueRoi, roiStructure, stopBillingApplicable, stopBillingDays, coolingPeriod, cashbackApplicable, dealerPerc, sellerPerc, progPerc, disbursalWaitDays, subventionPerc, subventionDays, additional_roi} = this.state;
        this.setState({
            show_api_err: false
        });
        const lending = this.props.isLendingScheme ? this.state.lending_partner : null;
        let tiered_array = [...this.state.tieredAboveArr, ...this.state.tieredBelowArr]
        if(this.state.tieredBelowArr.length){
            tiered_array.pop()
        }
        if(!this.state.tieredAboveArr.length){
            let fixedAboveArr = {
                "from_days:0": 1,
                "to_days:0": overdueTenor,
                "roi:0": normalRoi,
            };
            tiered_array.unshift(fixedAboveArr)
        }
        if(tiered_array.length > 2 ){
            let to_days = this.getValueByPrefix(tiered_array[2], 'to_days')
            if(to_days <= this.state.subventionDays){
                message.error("Please complete all required fields before proceeding")
                return 
            }
        }
        if (roiStructure == "Flat") {
            let roi_schedule = [
                {
                    "from_days": 1,
                    "to_days": overdueTenor,
                    "roi": normalRoi,
                    'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_1']
                },
                {
                    "from_days": Number(overdueTenor) + 1,
                    "to_days": 9999,
                    "roi": overdueRoi,
                    'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_2']
                },
            ];

            let submitData = {
                "lending_partner": lending,
                "margin": margin,
                "tenor": overdueTenor,
                "overdue_tenor": overdueTenor,
                "min_normal_roi": Number(normalRoi),
                "max_overdue_roi": Number(overdueRoi),
                "min_normal_roi_buyer": this.state.buyerRoi,
                "min_normal_roi_seller": this.state.sellerRoi,
                "is_roi_structure_flat": true,
                "roi_schedule": roi_schedule,
                "stop_billing_days": stopBillingDays,
                "cooling_period": coolingPeriod,
                "cashback_sharing_percentage_for_dealer": dealerPerc!=null?dealerPerc.toFixed(2):null,
                "cashback_sharing_percentage_for_seller": sellerPerc!=null?sellerPerc.toFixed(2):null,
                "cashback_sharing_percentage_for_progcap": progPerc,
                "disbursal_wait_days": disbursalWaitDays,
                "subvention_perc": subventionPerc,
                "subvention_days": subventionDays,
                "is_default_scheme": this.props.isDefaultScheme ? true : false,
                "scheme_type": this.props.schemeTypeData,
                "progcap_subvention_days": 0,
                "anchor_id": this.state.anchorId,
                "is_adhoc_applicable_on_overdue" : this.state.adhocApplicableOnOverdue,
                additional_roi
            };
            this.setState({
                loading: true
            });
            CompanyLosService.createNewScheme(this.props.companyId, submitData).then(({ data }) => {
                this.setState({
                    loading: false
                });
                message.success("Scheme Created Successfully");
                this.props.onSuccess();
                console.log("data", data);
            }).catch((err) => {
                this.setState({
                    loading: false,
                    show_api_err: true,
                    non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]  && err[Object.keys(err)][0] || "Please enter correct data",
                });
            });
        } else {
            let finalRoiArr = [];
            if(this.state.tieredAboveArr.length !== 0 && this.state.tieredBelowArr.length !== 0){
                finalRoiArr = this.state.tieredAboveArr.map(o => Object.fromEntries(Object.entries(o).map(([k, v]) => [k.split(":")[0], v]))).concat(this.state.tieredBelowArr.map(o => Object.fromEntries(Object.entries(o).map(([k, v]) => [k.split(":")[0], v]))));
            } else if (this.state.tieredAboveArr.length == 0 && this.state.tieredBelowArr.length == 0){
                let fixedAboveArr = {
                    "from_days": 1,
                    "to_days": overdueTenor,
                    "roi": normalRoi,
                    'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_1']
                };
                let fixedBelowArr = {
                    "from_days": Number(overdueTenor) + 1,
                    "to_days": 9999,
                    "roi": overdueRoi,
                    'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_2']
                };
                finalRoiArr = [fixedAboveArr, fixedBelowArr];
            }else{
                if (this.state.tieredAboveArr.length == 0) {
                    let AboveArr = [];
                    let data = {
                        "from_days": 1,
                        "to_days": overdueTenor,
                        "roi": normalRoi,
                        'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_1']
                    };
                    AboveArr.push(data);
                    // finalRoiArr.push(data);
                    finalRoiArr = AboveArr.concat(this.state.tieredBelowArr.map(o => Object.fromEntries(Object.entries(o).map(([k, v]) => [k.split(":")[0], v]))));
                    // finalRoiArr = AboveArr.concat(this.state.tieredBelowArr.map(o => Object.fromEntries(Object.entries(o).map(([k, v]) => [k.split(":")[0], v])))).concat(AboveArr);
                }
                if (this.state.tieredBelowArr.length == 0) {
                    let BellowArr = [];
                    let data = {
                        "from_days": Number(overdueTenor) + 1,
                        "to_days": 9999,
                        "roi": overdueRoi,
                        "adhoc_roi": this.state.adhoc_roi_flat['adhoc_roi_2']
                    };
                    BellowArr.push(data);
                    // finalRoiArr.push(data);
                    finalRoiArr = this.state.tieredAboveArr.map(o => Object.fromEntries(Object.entries(o).map(([k, v]) => [k.split(":")[0], v]))).concat(BellowArr);
                }
                
            }
            let submitData = {
                "lending_partner": lending,
                "margin": margin,
                "tenor": overdueTenor,
                "overdue_tenor": overdueTenor,
                "min_normal_roi": Number(normalRoi),
                "max_overdue_roi": Number(overdueRoi),
                "min_normal_roi_buyer": this.state.buyerRoi,
                "min_normal_roi_seller": this.state.sellerRoi,
                "is_roi_structure_flat": false,
                "roi_schedule": finalRoiArr,
                "stop_billing_days": stopBillingDays,
                "cooling_period": coolingPeriod,
                "cashback_sharing_percentage_for_dealer": dealerPerc!=null?dealerPerc.toFixed(2):null,
                "cashback_sharing_percentage_for_seller": sellerPerc!=null?sellerPerc.toFixed(2):null,
                "cashback_sharing_percentage_for_progcap": progPerc,
                "disbursal_wait_days": disbursalWaitDays,
                "subvention_perc": subventionPerc,
                "subvention_days": subventionDays,
                "is_default_scheme": this.props.isDefaultScheme ? true : false,
                "scheme_type": this.props.schemeTypeData,
                "progcap_subvention_days": 0,
                "anchor_id": this.state.anchorId,
                "is_adhoc_applicable_on_overdue" : this.state.adhocApplicableOnOverdue,
                additional_roi
            };
            this.setState({
                loading: true
            });
            CompanyLosService.createNewScheme(this.props.companyId, submitData).then(({ data }) => {
                this.setState({
                    loading: false
                });
                message.success("Scheme Created Successfully");
                this.props.onSuccess();
                console.log("data", data);
            }).catch((err) => {
                this.setState({
                    loading: false,
                    show_api_err: true,
                    non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)]  && err[Object.keys(err)][0] || "Please enter correct data",
                });
            });
        }

        console.log("aefawefae", margin, tenor, overdueTenor, normalRoi, overdueRoi, roiStructure, stopBillingApplicable, stopBillingDays, coolingPeriod, cashbackApplicable, dealerPerc, sellerPerc, disbursalWaitDays, sellerPerc, subventionPerc, subventionDays);
    }

    clearState(){
        this.setState({
            additional_roi : "",
            loading: false,
            lending_partner: null,
            margin: null,
            tenor: null,
            overdueTenor: null,
            normalRoi: null,
            overdueRoi: null,
            roiStructure: "Flat",
            stopBillingApplicable: "No",
            stopBillingDays: null,
            coolingPeriod: null,
            cashbackApplicable: "Yes",
            dealerPerc: 100,
            sellerPerc: 0,
            progPerc: 0,
            disbursalWaitDays: null,
            subventionPerc: 0,
            subventionDays: 0,
            count: 2,
            insertClick: null,
            insertAboveClick: false,
            insertBelowClick: false,
            countArr: [1],
            countBelow: null,
            countBelowArr: [],
            error: null,
            isTieredAboveEdited: false,
            isTieredBelowEdited: false,
            tieredAboveArr: [],
            tieredBelowArr: [],
            insertBelowArr: null,
            showInsert: true,
            to_days1Err: false,
            from_days2Err: false,
            roi2Err: false,
            aboveT_err_msg: null,
            non_field_error: null,
            show_api_err: false
        });
        this.props.stateCleared();
    }

    setFlatRoiStr(item){
        this.resetLastTiered();
        this.setState({
            roiStructure: item.target.value,
            additional_roi : this.state.overdueRoi - this.state.normalRoi,
            subventionPerc: 0,
            progcapSubventionDay : 0
        });
        this.resetTiered();
    }

    resetTiered(){
        this.setState({
            // adhoc_roi_flat: {
            //     'adhoc_roi_1' : "",
            //     'adhoc_roi_2' : ""
            // },
            tieredAboveArr: [],
            tieredBelowArr: [],
            isTieredBelowEdited: true,
            isTieredAboveEdited: true,
            showInsert: true
        });
    }

    onChange(value){
        this.setState({
            lending_partner: value
        });
    }
   
    checkTieredData = () => {
        if(this.state.tieredBelowArr.length){
            return false;
        } else if (this.state.tieredAboveArr.length){
            return false;
        }else{
            return true;
        }
    }
    render() {
        if(this.props.clearState){
            this.clearState();
        }
        return (
            <Row gutter={24}>
                <Col>
                    <Form>
                        <Row style={{marginBottom: "20px"}}>
                            <Col>
                                <Form.Item label={<span>Anchor <GenericToolTip toolTipData={<Icon style={{fontSize : 8 , verticalAlign : "text-top" , marginTop : 2}} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")}/></span>} required={true} style={{margin: "0"}}>
                                    {
                                        this.props.anchorList && this.props.anchorList.length == 1 ? <InputNumber style={{ width: "30%" }} value={this.props.anchorList[0].short_name} disabled={true} />:<Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select Anchor"
                                            optionFilterProp="children"
                                            onChange={(val) => this.setState({anchorId: val})}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.anchorList && this.props.anchorList.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.id} key={k}>{item.short_name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            this.props.isLendingScheme ? <Row style={{marginBottom: "20px"}}>
                                <Col>
                                    <Form.Item label="Partner Bank" required={true} style={{margin: "0"}}>
                                        <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select lending partner"
                                            optionFilterProp="children"
                                            onChange={(val) => this.onChange(val)}
                                            onSearch={(val)=>this.onSearch(val)}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.partnerbank && this.props.partnerbank.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.id} key={k}>{item.name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>:null
                        }
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={7}>
                                <Form.Item label={<span>Margin <GenericToolTip toolTipData={<Icon style={{fontSize : 8 , verticalAlign : "text-top" , marginTop : 2}} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("margin")}/></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("margin", "marginErr")} style={{ width: "100%" }} precision={2} type={"number"} value={this.state.margin} min={0} max={100} onChange={(item) => this.setState({margin: item}, this.fieldCheckValidations("Margin", item))} />
                                </Form.Item>
                                {this.state.marginErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={6} style={{margin: "0px 10px"}}>
                                <Form.Item label={<span>Tenor (days) <GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("tenor")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber 
                                    onBlur={() => this.focusOutEvent("overdueTenor", "tenorErr")} 
                                    style={{ width: "100%" }} 
                                    value={this.state.overdueTenor}
                                     onChange={(item) => {this.setState({
                                        overdueTenor: item,
                                        adhocApplicableOnOverdue: false,
                                        adhoc_roi_flat : {
                                            ...this.state.adhoc_roi_flat,
                                            'adhoc_roi_1' : MAX_ROI - this.state.normalRoi,
                                            'adhoc_roi_2' : 0
                                        },
                                    }, this.fieldCheckValidations("Tenor", item))}} 
                                     />
                                </Form.Item>
                                {this.state.tenorErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Overdue Tenor (days)<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("tenor")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.overdueTenor} className={"read-only-input"} onChange={(item) => this.setState({overdueTenor: item})} readOnly />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={7}>
                                <Form.Item label={<span>Normal ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("overdue_roi")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber 
                                    onBlur={() => this.focusOutEvent("normalRoi", "normalRoiErr")} 
                                    style={{width: "100%"}} 
                                    value={this.state.normalRoi} 
                                    precision={3} 
                                    onChange={(item) => this.setState({
                                        normalRoi: item, 
                                        additional_roi: (this.state.overdueRoi -  item).toFixed(3),
                                        adhoc_roi_flat: {
                                            'adhoc_roi_1' : "",
                                            'adhoc_roi_2' : ""
                                        },
                                        adhocApplicableOnOverdue: false,
                                        overdueRoi: ""
                                    }, this.fieldCheckValidations("Normal ROI", item))} 
                                />
                                </Form.Item>
                                {this.state.normalRoiErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={6} style={{marginLeft: "10px"}}>
                                <Form.Item label={<span>Overdue ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("overdue_roi")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber 
                                    onBlur={() => this.focusOutEvent("overdueRoi", "overdueRoiErr")} 
                                    precision={3} 
                                    style={{ width: "100%" }} 
                                    value={this.state.overdueRoi} 
                                    onChange={(item) => this.setState({
                                        overdueRoi: item, 
                                        additional_roi: (item - this.state.normalRoi).toFixed(3),
                                        adhoc_roi_flat : {
                                            ...this.state.adhoc_roi_flat,
                                            'adhoc_roi_1' : MAX_ROI - this.state.normalRoi,
                                            'adhoc_roi_2' : 0
                                        },
                                        adhocApplicableOnOverdue: false,
                                    }, this.fieldCheckValidations("Overdue ROI", item))} 
                                    />
                                </Form.Item>
                                {this.state.overdueRoiErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            
                            <Col span={6} style={{ margin: "0px 20px" }}>
                                <Form.Item label={<span>Is Adhoc Applicable On Overdue</span>}>
                                    <Radio.Group value={this.state.adhocApplicableOnOverdue}>
                                        <Radio.Button onChange={(item) => {
                                            if(!this.state.tieredAboveArr.length && !this.state.tieredBelowArr.length){
                                                this.setState({
                                                    adhoc_roi_flat : {
                                                        ...this.state.adhoc_roi_flat,
                                                        'adhoc_roi_2': this.state.adhoc_roi_flat['adhoc_roi_1'] 
                                                    }
                                                })
                                            }
                                            let roi = 0;

                                            if(this.state.tieredAboveArr.length && this.state.tieredBelowArr.length){
                                                if(this.state.tieredBelowArr.length >= 2){
                                                    roi = this.state.tieredBelowArr.slice(-2)[0]['adhoc_roi']
                                                }else{
                                                    roi = this.state.tieredAboveArr.slice(-1)[0]['adhoc_roi']
                                                }
                                            }

                                            if(this.state.tieredAboveArr.length && !this.state.tieredBelowArr.length){
                                                this.setState({
                                                    adhoc_roi_flat :{
                                                        ...this.state.adhoc_roi_flat,
                                                        adhoc_roi_2 : this.state.tieredAboveArr.slice(-1)[0]['adhoc_roi']
                                                    }
                                                })
                                            }

                                            if(this.state.tieredBelowArr.length && !this.state.tieredAboveArr.length){
                                                roi = this.state.tieredBelowArr.slice(-2)[0]['adhoc_roi']
                                            }
                                            
                                            if(roi){
                                                const updatedTieredBelow = [...this.state.tieredBelowArr];

                                                if (updatedTieredBelow.length > 0) {
                                                    const lastItem = updatedTieredBelow[updatedTieredBelow.length - 1];
                                                    lastItem['adhoc_roi'] = roi; // Replace 'newValue' with the value you want to set
                                                }
                                                this.setState({
                                                    tieredBelowArr : updatedTieredBelow
                                                })
                                            }
                                            this.setState({ adhocApplicableOnOverdue: true})
                                            }} value={true}>Yes</Radio.Button>
                                        <Radio.Button onChange={(item) => {
                                            if((!this.state.tieredBelowArr.length) || this.state.roiStructure == 'Flat'){
                                                this.setState({
                                                    adhoc_roi_flat : {
                                                        ...this.state.adhoc_roi_flat,
                                                        'adhoc_roi_2': 0 
                                                    }
                                                })
                                            }else{
                                                const updatedTieredBelow = [...this.state.tieredBelowArr];

                                                if (updatedTieredBelow.length > 0) {
                                                    const lastItem = updatedTieredBelow[updatedTieredBelow.length - 1];
                                                    lastItem['adhoc_roi'] = 0; // Replace 'newValue' with the value you want to set
                                                }
                                                this.setState({
                                                    tieredBelowArr : updatedTieredBelow
                                                });

                                            }
                                            this.setState({ adhocApplicableOnOverdue: false })
                                            }} value={false}>No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            </Row>  
                        {
                            this.props.schemeTypeData == 3 ?<Row style={{marginBottom: "20px"}}>
                                <Col span={8}>
                                    <Form.Item label={<span>Buyer ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("overdue_roi")} /></span>} required={true} style={{margin: "0"}}>
                                        <InputNumber style={{width: "100%"}} value={this.state.buyerRoi} precision={3} onChange={(item) => this.setState({buyerRoi: item}, this.fieldCheckValidations("Buyer ROI", item))} />
                                    </Form.Item>
                                    {this.state.buyerRoiErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                                </Col>
                                <Col span={8} style={{marginLeft: "10px"}}>
                                    <Form.Item label={<span>Seller ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("overdue_roi")} /></span>} required={true} style={{margin: "0"}}>
                                        <InputNumber className={"read-only-input"} onBlur={() => this.focusOutEvent("sellerRoi", "sellerRoiErr")} precision={3} style={{ width: "100%" }} value={this.state.sellerRoi} onChange={(item) => this.setState({sellerRoi: item}, this.fieldCheckValidations("Seller ROI", item))} readOnly />
                                    </Form.Item>
                                    {this.state.sellerRoiErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                                </Col>
                            </Row>:null
                        }
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={18}>
                                <Form.Item label={<span>ROI Structure<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("roi_structure")} /></span>} name="roiStructure" required={true} style={{margin: "0"}}>
                                    <Radio.Group value={this.state.roiStructure}>
                                        <Radio.Button onChange={(item) => this.setFlatRoiStr(item)} default value={"Flat"}>Flat</Radio.Button>
                                        <Radio.Button onChange={(item) => this.setTieredData(item)} value={"Tiered"}>Tiered</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col style={{marginTop: "20px"}}>
                                {this.renderFlatTieredSection()}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={9} style={{ marginLeft: "10px" }}>
                                <Form.Item label={<span>Actual Overdue ROI</span>}>
                                    <InputNumber
                                        disabled
                                        style={{ width: "100%" }}
                                        value={this.state.additional_roi}
                                        onChange={(item) => this.setState({
                                            additional_roi: item
                                        })}
                                    />
                                    {(this.state.additional_roi < 0 || this.state.additional_roi > this.state.overdueRoi) && <span style={{ fontSize: "11px", color: "red" }}>Value cannot be less than 0 or greter than Overdue ROI</span>}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={7}>
                                <Form.Item label={<span>Stop Billing Applicable<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("stop_billing_applicable")} /></span>} name="stopBillingApplicable" required={true} style={{margin: "0"}}>
                                    <Radio.Group value={this.state.stopBillingApplicable}>
                                        <Radio.Button onChange={(item) => this.setState({stopBillingApplicable: item.target.value})} value="Yes">Yes</Radio.Button>
                                        <Radio.Button onChange={(item) => this.setState({stopBillingApplicable: item.target.value, stopBillingDays: null})} value="No">No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{margin: "0px 10px"}}>
                                <Form.Item label={<span>Stop Billing Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("stop_billing_days")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("stopBillingDays", "stopBillingDayErr")} style={{ width: "100%" }} value={this.state.stopBillingDays} className={this.state.stopBillingApplicable=="No"?"read-only-input":null} onChange={(item) => this.setState({stopBillingDays: item}, this.fieldCheckValidations("Stop Billing Days", item))} readOnly={this.state.stopBillingApplicable=="No"?true:false} />
                                </Form.Item>
                                {this.state.stopBillingDayErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Cooling Period<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("cooling_period")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("coolingPeriod", "cpErr")} style={{ width: "100%" }} value={this.state.coolingPeriod} onChange={(item) => this.setState({coolingPeriod: item}, this.fieldCheckValidations("Cooling Period", item))} />
                                </Form.Item>
                                {this.state.cpErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={5}>
                                <Form.Item label={<span>Cashback Applicable<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("cashback_applicable")} /></span>} name="cashbackApplicable" required={true} style={{margin: "0"}}>
                                    <Radio.Group value={this.state.cashbackApplicable}>
                                        <Radio.Button onChange={(item) => this.setState({cashbackApplicable: item.target.value, dealerPerc: 100, sellerPerc: 0, progPerc: 0})} value="Yes">Yes</Radio.Button>
                                        <Radio.Button onChange={(item) => this.setState({cashbackApplicable: item.target.value, dealerPerc: null, sellerPerc: null, progPerc: null, subventionPerc: 0, subventionDays: 0})} value="No">No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col span={5} style={{margin: "0px 10px"}}>
                                <Form.Item label={<span>Dealer %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("dealer_perc")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("dealerPerc", "dealerPerErr")} precision={2} style={{ width: "100%" }} value={this.state.dealerPerc} onChange={(item) => this.setState({dealerPerc: item}, this.fieldCheckValidations("Dealer %", item))} className={this.state.cashbackApplicable == "No"?"read-only-input":null} readOnly={this.state.cashbackApplicable == "No"?true:false} />
                                </Form.Item>
                                {this.state.dealerPerErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={5} style={{margin: "0px 10px"}}>
                                <Form.Item label={<span>Seller %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("seller_perc")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("sellerPerc", "sellerPerErr")} precision={2} style={{ width: "100%" }} value={this.state.sellerPerc} onChange={(item) => this.setState({sellerPerc: item}, this.fieldCheckValidations("Seller %", item))} className={this.state.cashbackApplicable=="No"?"read-only-input":null} readOnly={this.state.cashbackApplicable == "No"?true:false} />
                                </Form.Item>
                                {this.state.sellerPerErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={5}>
                                <Form.Item label={<span>Progcap %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("progcap_perc")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber readOnly={true} onBlur={() => this.focusOutEvent("progPerc", "progPerErr")} precision={2} style={{ width: "100%" }} value={this.state.progPerc} onChange={(item) => this.setState({progPerc: item}, this.fieldCheckValidations("Progcap %", item))} className={"read-only-input"} />
                                </Form.Item>
                                {this.state.progPerErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        <Row style={{marginBottom: "20px"}}>
                            <Col span={7}>
                                <Form.Item label={<span>Disbursal Wait Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("disbursalWaitDays", "disbursalWaitDaysErr")} style={{ width: "100%" }} value={this.state.disbursalWaitDays} onChange={(item) => this.setState({disbursalWaitDays: item}, this.fieldCheckValidations("Disbursal wait days", item))} />
                                </Form.Item>
                                {this.state.disbursalWaitDaysErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={6} style={{margin: "0px 10px"}}>
                                <Form.Item label={<span>Subvention %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("subvention_perc")} /></span>}required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("subventionPerc", "subventionPercErr")} precision={2} style={{ width: "100%" }} value={this.state.subventionPerc} onChange={(item) => this.setState({subventionPerc: item}, this.fieldCheckValidations("Subvention %", item))} className={this.state.cashbackApplicable =="No"?"read-only-input":null} readOnly={this.state.cashbackApplicable == "No"?true:false} />
                                </Form.Item>
                                {this.state.subventionPercErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Subvention Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></span>} required={true} style={{margin: "0"}}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.subventionDays} onChange={(item) => this.setState({subventionDays: item})}  className={"read-only-input"} readOnly />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Row>
                            {
                                this.state.show_api_err?<Col className={"m-5"}>
                                    <span className={"error-text"}>* {this.state.non_field_error}</span>
                                </Col>:null
                            }
                            <Col span={7}>
                                <Button onClick={() => this.onSchemeAddClick()} loading={this.state.loading} disabled={this.checkSubmit() || this.state.roiStructure === "Tiered" && this.checkTieredData()} className={"ant-btn ant-btn-primary"}>Submit</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        );
    }
}

AddCombinationalSchemeDetail.propTypes = {
    form: PropTypes.object,
    companyId: PropTypes.string,
    isDefaultScheme: PropTypes.bool,
    isLendingScheme: PropTypes.bool,
    clearState: PropTypes.bool,
    stateCleared: PropTypes.func,
    partnerbank: PropTypes.array,
    onSuccess: PropTypes.func,
    schemeType: PropTypes.string,
    schemeTypeData: PropTypes.string,
    anchorList: PropTypes.array
};

export default Form.create({})(AddCombinationalSchemeDetail);